import { Route, Routes } from 'react-router-dom';
import SiteList from './SiteList';
import SignInScreen from '../auth/SignInScreen';
import { isAdminEmail, useIsSignedIn, useIsSuperAdmin, useUserEmail } from '../util/DataStore';
import Site from './Site';
import Privacy from './Privacy';
import UserList from './UserList';

export const MainPage = () => {
  const [isSignedIn] = useIsSignedIn();
  const [email] = useUserEmail();
  useIsSuperAdmin();
  const admin = isAdminEmail(email);
  return (
    <Routes>
      <Route path="/" element={isSignedIn ? <SiteList /> : SignInScreen} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/login" element={<SignInScreen />} />
      {isSignedIn && <Route path="/site/*" element={<Site />} />}
      {isSignedIn && <Route path="/sites" element={<SiteList />} />}
      {isSignedIn && admin && <Route path="/users" element={<UserList />} />}
    </Routes>
  );
};

export default MainPage;
